module.exports = __webpack_public_path__ + "static/media/worship_map.13f84168.svg";